import React from 'react';
import { PublicHeroSection } from '@mts/ui';
import { usePublicTenant } from '../../hooks/usePublicTenant';
import { useLayoutViewport } from '../layout/LayoutViewportContext';

function HeroSection({ onExploreDirectory, onExploreDeals, onExploreEvents }) {
  const { isMobile } = useLayoutViewport();
  const {
    spotlightName,
    heroImageUrl,
    heroOverlayStrength,
    heroFocalX,
    heroFocalY,
    heroStyle,
    brandTheme,
  } = usePublicTenant();
  return (
    <PublicHeroSection
      spotlightName={spotlightName}
      heroImageUrl={heroImageUrl}
      heroOverlayStrength={heroOverlayStrength}
      heroFocalX={heroFocalX}
      heroFocalY={heroFocalY}
      heroStyle={heroStyle}
      brandTheme={brandTheme}
      hideSubtitleOnMobile={isMobile}
      hideSecondaryCtasOnMobile={isMobile}
      onExploreDirectory={onExploreDirectory}
      onExploreDeals={onExploreDeals}
      onExploreEvents={onExploreEvents}
    />
  );
}

export default HeroSection;
